module.exports = __webpack_public_path__ + "img/car.3a8e57ac.svg";